<template>
  <component :is="item.url ? 'a' : 'div'"
    class="ss__desktop__menu__item"
    :style="item.style"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <div v-if="item.image" class="ss__desktop__menu__item__image__wrapper">
      <img
        class="ss__desktop__menu__item__image"
        :src="$formatImageSrc(item.image, { w: 360, h: 200 }) || $app.imgErrorSrc"
        :alt="item.name"
      />
    </div>
    <div class="ss__desktop__menu__item__content">
      <i v-if="item.icon" :class="['ss__desktop__menu__item__icon', item.icon]"/>
      <span class="ss__desktop__menu__item__name">{{ item.name }}</span>
      <i v-if="item.url && item.external" class="ssCommunityIcon__arrowTopRight"/>
    </div>
    <div
      v-if="item.description"
      class="ss__desktop__menu__item__desc">
      {{ item.description }}
    </div>
  </component>
</template>

<script>
export default {
  name: 'SsDesktopMenuItem',

  props: {
    item: {
      type: Object
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__menu__item {
  display: block;
  cursor: pointer;
  .ss__desktop__menu__item__content {
    display: flex;
    align-items: center;
    column-gap: var(--gap-SsDesktopMenuItemContent, 4px);
    width: var(--w-SsDesktopMenuItemContent, 100%);
    height: var(--h-SsDesktopMenuItemContent, 24px);
    overflow: hidden;
  }

  .ss__desktop__menu__item__icon {
    font-size: var(--size-SsDesktopMenuItemIcon, 24px);
    padding: var(--padding-SsDesktopMenuItemIcon, 0px);
    color: var(--color-SsDesktopMenuItemIcon, var(--B8-t));
    transition: .2s;
    order: var(--order-SsDesktopMenuItemIcon, 0);
  }
  .ss__desktop__menu__item__name {
    font-family: var(--font-SsDesktopMenuItemName, inherit);
    font-size: var(--text-SsDesktopMenuItemName, 15px);
    font-weight: var(--weight-SsDesktopMenuItemName, 500);
    color: var(--color-SsDesktopMenuItemName, var(--B8-t));
    transition: .2s;
  }
  .ssCommunityIcon__arrowTopRight {
    font-size: var(--text-SsDesktopMenuItemIconExternal, 16px);
    color: var(--color-SsDesktopMenuItemIconExternal, var(--B5-t));
  }

  .ss__desktop__menu__item__image {
    width: var(--w-SsDesktopMenuItemImage, 180px);
    height: var(--h-SsDesktopMenuItemImage, 100px);
    border-radius: var(--radius-SsDesktopMenuItemImage, 8px);
    border: var(--border-SsDesktopMenuItemImage, (1px solid rgba(0, 0, 0, 0.05)));
    margin: var(--margin-SsDesktopMenuItemImage, (0px 0px 8px));
    object-fit: cover;
    box-sizing: border-box;
  }

  .ss__desktop__menu__item__desc {
    width: var(--h-SsDesktopMenuItemDesc, 180px);
    font-size: var(--text-SsDesktopMenuItemDesc, 13px);
    font-weight: var(--weight-SsDesktopMenuItemDesc, 400);
    color: var(--text-SsDesktopMenuItemDesc, var(--B6-t));
    margin: var(--margin-SsDesktopMenuItemImage, (4px 0px 0px));
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
